// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_m5-0";
export var buttonContainer = "_m5-3";
export var cancelButton = "_m5-4";
export var headerSection = "_m5-6";
export var headerTitle = "_m5-9";
export var messageSideLeft = "_m5-1";
export var messageSideRight = "_m5-2";
export var orderNumberContainer = "_m5-7";
export var orderNumberLabel = "_m5-8";
export var submitButton = "_m5-5";